import { render, staticRenderFns } from "./SimpleImageDialog.vue?vue&type=template&id=c4ef7f98&scoped=true&"
import script from "./SimpleImageDialog.vue?vue&type=script&lang=js&"
export * from "./SimpleImageDialog.vue?vue&type=script&lang=js&"
import style0 from "./SimpleImageDialog.vue?vue&type=style&index=0&id=c4ef7f98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4ef7f98",
  null
  
)

export default component.exports